// Information about each person on the CSUS executive team
import johann  from '../images/johann.png'
import michael  from '../images/michael.jpeg'
import nicole  from '../images/nicole.png'
import sue  from '../images/sue.png'
import karen from '../images/karen.jpg'
import maya from '../images/maya.jpg'
import sinthuja from '../images/sinthuja.jpeg'
import tanusri from '../images/tanusri.jpg'
import pranav from '../images/pranav.jpeg'

const people = [
    {
        name: 'Johann Cardenas',
        image: johann,
        role: 'Co-President',
        major: 'Bioiniformatics',
        email: 'jcarden4@uwo.ca',
        description: 'Johann is a fourth year Bioinformatics student who previously interned at Engineering.com and Designware.',
        linkedin: 'https://www.linkedin.com/in/jcard33/',
    },
    {
        name: 'Pranav Varma',
        image: pranav,
        role: 'VP Projects',
        major: 'Computer Science',
        email: 'yuvraj.virdi@live.com',
        linkedin: 'https://www.linkedin.com/in/pranavarma/',
        description: 'Yuvraj is a second year Computer Science student who previously interned at Unify.'
    },
    {
        name: 'Tanusri Harish',
        image: tanusri,
        role: 'VP Finance',
        major: 'Computer Science',
        email: 'hahme3@uwo.ca',
        linkedin: 'https://www.linkedin.com/in/tanusri-harish-728a1022a/',
        description: 'Habib is a fifth year Computer Science student who previously interned at DocuSign and Citi Bank.'
    },
    {
        name: 'Nicole Moskovitch',
        image: nicole,
        role: 'Co-President',
        major: 'Computer Science and Ivey',
        email: 'nmoskovi@uwo.ca',
        linkedin: 'https://www.linkedin.com/in/nicole-moskovitch/',
        description: 'Nicole is a third year Computer Science and Ivey student who is interested in artificial intelligence.'
    },
    {
        name: 'Maya Al Hourani',
        image: maya,
        role: 'VP Internal Affairs',
        major: 'Computer Science',
        email: 'malhour3@uwo.ca',
        linkedin: 'https://www.linkedin.com/in/maya-al-hourani-298aa8222',
        description: 'Johann is a fourth year Bioinformatics student who previously interned at Engineering.com and Designware.'
    },
    {
        name: 'Sue Han',
        image: sue,
        role: 'VP Marketing',
        major: 'Computer Science',
        email: 'zhan246@uwo.ca',
        linkedin: 'https://www.linkedin.com/in/suehan-/',
        description: 'Sue is a second year Computer Science student who is interested in artificial intelligence and fintech.'
    },
    {
        name: 'Karen Zhan',
        image: karen,
        role: 'VP Events',
        major: 'Computer Science and Ivey',
        email: 'nmoskovi@uwo.ca',
        linkedin: 'https://www.linkedin.com/in/suehan-/',
        description: 'Nicole is a third year Computer Science and Ivey student who is interested in artificial intelligence.'
    },
    {
        name: 'Sinthuja Jeevarajhan',
        image: sinthuja,
        role: 'VP External Affairs',
        major: 'Computer Science and French Studies',
        email: 'mtiwana4@uwo.ca',
        linkedin: 'https://www.linkedin.com/in/sinthuja-jeevarajhan-627037222/',
        description: 'Moneet is a fouth year Computer Science and French Studies student who previously interned at J.D. Power.'
    },
    {
        name: 'Michael Gao',
        image: michael,
        role: 'VP Academics',
        major: 'Computer Science and Ivey',
        email: 'mgao244@uwo.ca',
        linkedin: 'https://www.linkedin.com/in/michael-gao-1903221ba/',
        description: 'Moneet is a fouth year Computer Science and French Studies student who previously interned at J.D. Power.'
    }
]

export default people;